import { Button } from '../../../../../components/button/button';
import { Checkbox } from '../../../../../components/checkbox/checkbox';
import { Card } from '../../../../../components/card/card';
import { InputFileSquare } from '../../../../../components/input-file/input-file-square/input-file-square';
import { Label } from '../../../../../components/label/label';
import { Loader } from '../../../../../components/loader/loader';
import { Page } from '../../../../../components/page/page';
import { Select } from '../../../../../components/select/select';
import s from './app-settings.module.css';
import { RgbInputs } from './rgb-inputs';
import { useAppSettings } from './use-app-settings';
import { Container } from '../../../../../components/container/container';

export const AppSettings = () => {
  const {
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
    t,
    app,
    handleUpdateCompanyProfile,
    defaultFonts,
    handleUploadLogo,
    handleUploadBg,
    isSavingImage,
    isImage,
    toggleIsImage,
    background,
    logo,
  } = useAppSettings();

  return (
    <Page className={s.page}>
      {isLoading && <Loader />}
      <h2 className={s.header}>
        {t('Настройки клиентского приложения')}
        <div className={s.controls}>
          <Button variant="secondary" onClick={disabled ? toggleDisabled : handleCancel}>
            {disabled ? t('Изменить') : t('Отменить')}
          </Button>
          {!disabled && <Button onClick={handleSave}>{t('Сохранить')}</Button>}
        </div>
      </h2>
      <div className={s.content}>
        <Card className={s.card}>
          <RgbInputs
            label={t('Основной цвет')}
            disabled={disabled}
            value={app?.colors?.primary?.elements}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    primary: { ...app?.colors?.primary, elements: e },
                  },
                },
              })
            }
          />
          <RgbInputs
            label={t('Цвет текста внутри основного цвета')}
            disabled={disabled}
            value={app?.colors?.primary?.text}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    primary: { ...app?.colors?.primary, text: e },
                  },
                },
              })
            }
          />
          <RgbInputs
            label={t('Дополнительный цвет')}
            disabled={disabled}
            value={app?.colors?.secondary?.elements}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    secondary: { ...app?.colors?.secondary, elements: e },
                  },
                },
              })
            }
          />
          <RgbInputs
            label={t('Цвет текста внутри дополнительного цвета')}
            disabled={disabled}
            value={app?.colors?.secondary?.text}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    secondary: { ...app?.colors?.secondary, text: e },
                  },
                },
              })
            }
          />
          <RgbInputs
            label={t('Цвет фона иконок')}
            disabled={disabled}
            value={app?.colors?.icon?.bg}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    icon: { ...app?.colors?.icon, bg: e },
                  },
                },
              })
            }
          />
          <RgbInputs
            label={t('Цвет контура иконок')}
            disabled={disabled}
            value={app?.colors?.icon?.stroke}
            onChange={(e) =>
              handleUpdateCompanyProfile({
                app: {
                  ...app,
                  colors: {
                    ...app?.colors,
                    icon: { ...app?.colors?.icon, stroke: e },
                  },
                },
              })
            }
          />
        </Card>
        <Card className={s.card}>
          <Container label={t('Шрифт')}>
            <Select
              options={defaultFonts}
              value={defaultFonts.find((e) => e.value === app?.font)}
              disabled={disabled}
              onSelect={(e) => handleUpdateCompanyProfile({ app: { ...app, font: e.value } })}
            />
          </Container>

          <Container label={t('Логотип')}>
            <InputFileSquare
              onChange={handleUploadLogo}
              types={['image/*']}
              className={s.inputFile}
              src={logo}
              disabled={disabled}
              isLoading={isSavingImage}
              deletable={!!logo}
            />
          </Container>

          <div className={s.background}>
            <Label>{t('Фон')}</Label>
            <Checkbox
              label={t('Изображение')}
              checked={isImage}
              onClick={toggleIsImage}
              disabled={disabled}
            />
          </div>

          {isImage ? (
            <InputFileSquare
              onChange={handleUploadBg}
              types={['image/*']}
              className={s.inputFile}
              src={background}
              disabled={disabled}
              isLoading={isSavingImage}
              deletable={background?.startsWith('http')}
            />
          ) : (
            <RgbInputs
              label={t('Цвет фона')}
              value={app?.background}
              disabled={disabled}
              onChange={(e) => {
                handleUpdateCompanyProfile({
                  app: { ...app, background: e },
                });
              }}
            />
          )}
        </Card>
      </div>
    </Page>
  );
};
